var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageSize main"},[_c('div',{staticClass:"title_borderground"},[_c('div',{staticClass:"title_borderground_content1"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"title_borderground_content2"},[_vm._v(" 专业健康知识")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }